import './NoData.scss';

const NoData = () => (
    <div className="no-data" data-testid="no-data">
        Данные отсутствуют <span lang="ja">¯\_(ツ)_/¯</span>
    </div>
);

export default NoData;
